import React from 'react';
import { Route, Routes } from 'react-router-dom';
import UserDocPage from './UserDocPage';

export default function DocumentsPage() {
  return (
    <Routes>
      <Route path=':type' element={<UserDocPage />} />
    </Routes>
  );
}
